import { render, staticRenderFns } from "./CompanyDetails.vue?vue&type=template&id=5011eb9a&"
import script from "./CompanyDetails.vue?vue&type=script&lang=ts&"
export * from "./CompanyDetails.vue?vue&type=script&lang=ts&"
import style0 from "./CompanyDetails.vue?vue&type=style&index=0&id=5011eb9a&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports